import visaLogo from '../../assets/cards/visa.png';
import masterLogo from '../../assets/cards/master.png';
import amexLogo from '../../assets/cards/amex.png';
import discoverLogo from '../../assets/cards/discover.png';
import rupayLogo from '../../assets/cards/rupay.png';
export const CARD_BRANDS = [
  {
    name: "visa",
    pattern: /^4/,
    validLengths: [13, 16, 19],
    cvvLength: 3,
    logo: visaLogo
  },
  {
    name: "mastercard",
    pattern: /^(5[1-5]|2[2-7])/,
    validLengths: [16],
    cvvLength: 3,
    logo: masterLogo
  },
  {
    name: "amex",
    pattern: /^3[47]/,
    validLengths: [15],
    cvvLength: 4,
    logo: amexLogo
  },
  {
    name: "discover",
    pattern: /^6(?:011|5)/,
    validLengths: [16, 19],
    cvvLength: 3,
    logo: discoverLogo
  },
  {
    name: "rupay",
    pattern: /^(60|65|81|82|508)/,
    validLengths: [16],
    cvvLength: 3,
    logo: rupayLogo
  }
];

// Detect card brand
export const detectCardBrand = (cardNumber) => {
  const cleaned = cardNumber.replace(/\D/g, "");
//   return CARD_BRANDS.find(brand => cleaned.match(brand.pattern)) || null;
  const brand = CARD_BRANDS.find(b => b.pattern.test(cleaned));
  return brand ? { ...brand } : null;

};

// Luhn algorithm
export const luhnCheck = (cardNumber) => {
  const arr = cardNumber.split("").reverse().map(d => parseInt(d, 10));
  const sum = arr.map((digit, idx) => {
    if (idx % 2 === 1) {
      const double = digit * 2;
      return double > 9 ? double - 9 : double;
    }
    return digit;
  }).reduce((a,b) => a + b, 0);
  return sum % 10 === 0;
};

// Format card number with spaces
export const formatCardNumber = (cardNumber) => {
  return cardNumber.replace(/\D/g, "").replace(/(.{4})/g, "$1 ").trim();
};